import { QueryOptions } from "../components/Common/useQuery";
import usePaginatedQuery, { PaginatedResult, PaginationParams } from "./usePaginatedQuery";
import { useUserOrKaEmployee } from "../components/UserAccess/useUserOrKaEmployee";

export interface ExternalIntegrationRequestDto {
  id: string;
  externalIntegrationId: string;
  timestamp: string;
  method: string;
  path: string;
  version: string;
  body: string | null;
  responseStatusCode: number | null;
  responseBody: string | null;
}

const useGetExternalIntegrationRequests = (
  params: PaginationParams,
  options?: QueryOptions<PaginatedResult<ExternalIntegrationRequestDto>>
) => {
  const user = useUserOrKaEmployee();
  return usePaginatedQuery<ExternalIntegrationRequestDto>(
    `/api/businesses/${user.selectedBusiness!.id}/externalIntegrationRequests`,
    params,
    options
  );
};

export default useGetExternalIntegrationRequests;
